import InfoMark from "@/assets/icons/info.svg?react";

import styles from "./styles";

export const WarningBlock = ({ text }: { text: string }) => {
  return (
    <styles.Container>
      <InfoMark />
      {text}
    </styles.Container>
  );
};
